import {
  Button,
  Card,
  Switch,
  Table,
  Tooltip,
  Input,
  Row,
  Col,
  DatePicker,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Plus from "../../assets/images/plus.svg";
import DeleteModal from "../../components/DeleteModal";
import apiPath from "../../constants/apiPath";
import { AppStateContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import { useNavigate } from "react-router";
import { APIServices } from "../../services/AuthAPIs";
import { Link } from "react-router-dom";

const { RangePicker } = DatePicker;

function Index() {
  const heading = "Support System";
  const { setPageHeading } = useContext(AppStateContext);
  const Search = Input.Search;
  const sectionName = "support";
  const urlParams = new URLSearchParams(window.location.search);
  const path = urlParams.get("status");
  const { deleteData, getData } = APIServices();

  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const navigate = useNavigate();


  const columns = [
    {
      title: "Name",
      dataIndex: "user_id",
      key: "user_id",
      width: 200,
      sorter: (a, b) => a.user_id?.name?.localeCompare(b.user_id?.name),
      render: (_, { user_id }) => {
        return user_id ? user_id?.name : "-";
      },
    },
   
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
      // sorter: (a, b) => a.email?.localeCompare(b.email),
      render: (_, { user_id }) => {
        return user_id ? (
          <span style={{ textTransform: "lowercase" }}>{user_id?.email}</span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Query Message",
      dataIndex: "message",
      key: "message",
      width: 200,
      render: (_, { message }) => {
        return message ? message : "-";
      },
    },
    {
      title: "Query On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return moment(created_at).format("ll");
      },
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
          
            <Tooltip title={("View")} color={"purple"} key={"View"}>
              <Button
                title="View"
                className="edit-cls primary_btn"
                onClick={() => {
                  setSelected(record);
                  // showDeleteModal(true);
                }}
              >
                <Link to={`/support/${record?._id}`} >
                  <i class="far fa-eye"></i>
                </Link>
              </Button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: 10 });
  };

  const handleChange = (pagination, filters) => {
    const payload = {
      page: pagination.current || 1,
      pageSize: pagination.pageSize || 10,
      search: debouncedSearchText,
      status: "",
      startDate: "",
      endDate: "",
    };
    getData(
      apiPath.getSupport,
      payload,
      setList,
      setLoading,
      setPagination,
      pagination
    );
  };

 

  useEffect(() => {
    setLoading(true);
    const payload = {
      page: pagination.current || 1,
      pageSize: pagination.pageSize || 10,
      search: debouncedSearchText,
      status: "",
      startDate: "",
      endDate: "",
    };
    getData(
      apiPath.getSupport,
      payload,
      setList,
      setLoading,
      setPagination,
      pagination
    );
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    setPageHeading(heading);
  }, [setPageHeading]);

  return (
    <>
      <div className="tabled productCaralogue">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={"Query List"}
              extra={
                <>
                  {/* <div className="button_group justify-content-end w-100">
                    <Search
                      allowClear
                      className="search-input"
                      size="large"
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      placeholder="Search By Name, email, number"
                      title="Search By Name, email, number"
                    />
                    <RangePicker
                      disabledDate={(current) => current.isAfter(Date.now())}
                      onChange={handleChangeDate}
                    />

                    <Button
                      className="primary_btn btnStyle"
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      <span className="add-Ic">
                        <img src={Plus} />
                      </span>
                      {"Add"} {sectionName}
                    </Button>
                  </div> */}
                </>
              }
            >
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

     
      
    </>
  );
}

export default Index;
